import { makeAutoObservable, runInAction } from 'mobx';
import { apiClient } from '../api/apiclient';
import { academyStore } from './AcademyStore';
export class BatchStore {
    constructor() {
        this.batches = [];
        this.loading = false;
        this.error = null;
        this.selectedBatch = null;
        this.isDialogOpen = false;
        this.isEditing = false;
        makeAutoObservable(this);
    }
    // Actions
    async fetchBatches(academyId, filters) {
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.getBatchesByAcademyId(academyId, filters);
            if (response.success) {
                runInAction(() => {
                    this.batches = response.data;
                    this.loading = false;
                });
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to fetch batches';
                this.loading = false;
            });
        }
    }
    async createBatch(batchData) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.createBatch(academyStore.currentAcademy.id, batchData);
            if (response.success) {
                runInAction(() => {
                    this.batches.unshift(response.data);
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to create batch';
                this.loading = false;
            });
            throw error;
        }
    }
    async updateBatch(id, batchData) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.updateBatch(academyStore.currentAcademy.id, id, batchData);
            if (response.success) {
                runInAction(() => {
                    const index = this.batches.findIndex(batch => batch.id === id);
                    if (index !== -1) {
                        this.batches[index] = response.data;
                    }
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to update batch';
                this.loading = false;
            });
            throw error;
        }
    }
    async deleteBatch(id) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.deleteBatch(academyStore.currentAcademy.id, id);
            if (response.success) {
                runInAction(() => {
                    this.batches = this.batches.filter(batch => batch.id !== id);
                    this.loading = false;
                });
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to delete batch';
                this.loading = false;
            });
            throw error;
        }
    }
    async addCoachesToBatch(batchId, coachIds) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.addCoachesToBatch(academyStore.currentAcademy.id, batchId, coachIds);
            if (response.success) {
                runInAction(() => {
                    const index = this.batches.findIndex(batch => batch.id === batchId);
                    if (index !== -1) {
                        this.batches[index] = response.data;
                    }
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to add coaches to batch';
                this.loading = false;
            });
            throw error;
        }
    }
    async removeCoachesFromBatch(batchId, coachIds) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.removeCoachesFromBatch(academyStore.currentAcademy.id, batchId, coachIds);
            if (response.success) {
                runInAction(() => {
                    const index = this.batches.findIndex(batch => batch.id === batchId);
                    if (index !== -1) {
                        this.batches[index] = response.data;
                    }
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to remove coaches from batch';
                this.loading = false;
            });
            throw error;
        }
    }
    async addPlayersToBatch(batchId, playerIds) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.addPlayersToBatch(academyStore.currentAcademy.id, batchId, playerIds);
            if (response.success) {
                runInAction(() => {
                    const index = this.batches.findIndex(batch => batch.id === batchId);
                    if (index !== -1) {
                        this.batches[index] = response.data;
                    }
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to add players to batch';
                this.loading = false;
            });
            throw error;
        }
    }
    async removePlayersFromBatch(batchId, playerIds) {
        if (!academyStore.currentAcademy) {
            throw new Error('No academy selected');
        }
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.removePlayersFromBatch(academyStore.currentAcademy.id, batchId, playerIds);
            if (response.success) {
                runInAction(() => {
                    const index = this.batches.findIndex(batch => batch.id === batchId);
                    if (index !== -1) {
                        this.batches[index] = response.data;
                    }
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to remove players from batch';
                this.loading = false;
            });
            throw error;
        }
    }
    // Dialog actions
    openCreateDialog() {
        this.selectedBatch = null;
        this.isEditing = false;
        this.isDialogOpen = true;
    }
    openEditDialog(batch) {
        this.selectedBatch = batch;
        this.isEditing = true;
        this.isDialogOpen = true;
    }
    closeDialog() {
        this.isDialogOpen = false;
        this.selectedBatch = null;
        this.isEditing = false;
    }
    // Computed
    get hasBatches() {
        return this.batches.length > 0;
    }
    get isLoading() {
        return this.loading;
    }
    get hasError() {
        return this.error !== null;
    }
}
export const batchStore = new BatchStore();
